// import HelloWorld from '@/components/HelloWorld'
import { getCookie } from '../../static/js/cookie'
import Index from '@/components/Index'
import Register from '@/components/Register'
import SignIn from '@/components/SignIn'
import Home from '@/components/Home'
import Center from '@/components/Center'
import Information from '@/components/Information'
import Recharge from '@/components/Recharge'
import Consumption from '@/components/Consumption'
import Withdrawal from "../components/Withdrawal.vue";
import Rechargeing from '@/components/Rechargeing'
import Forget from '@/components/Forget'
import aboutus_details from '@/components/aboutus_details'
import problem_details from '@/components/problem_details'
import aboutxy_details from '@/components/aboutxy_details'
import Edition_details from '@/components/Edition_details'
import game_details from '@/components/game_details'
import manual_details from '@/components/manual_details'
import security from '@/components/security'
import Real_name from '@/components/Real_name'
import card from '@/components/card'
import Transfer from '@/components/Transfer'
import gift_card from '@/components/gift_card'
import InviteBonusList from '@/components/InviteBonusList'
import BindWx from '@/components/BindWx'

import UserLicense from '@/components/UserLicense'
import PrivacyPolicy from '@/components/PrivacyPolicy'

import DownLoad from '@/components/DownLoad'
import Contact from '@/components/Contact'
import faq from '@/components/faq'
import CenterNav from '@/components/CenterNav'

// yhb 新闻
import Blog from '@/components/Blog.vue'
import Article_details from '@/components/Article_details'
// Yang
import GameProblem from '@/components/CommonProblem/GameProblem'
import Account from '@/components/CommonProblem/Account'
import Pay from '@/components/CommonProblem/Pay'
import Setup from '@/components/CommonProblem/Setup'
import Maiboxes from '@/components/CommonProblem/Maiboxes'
import Safety from '@/components/CommonProblem/Safety'
import Community from '@/components/CommonProblem/Community'
import Client from '@/components/CommonProblem/Client'
import activity from '@/components/CommonProblem/activity'

// yhb 常见问题 游戏问题
import Problem_a from '@/components/CommonProblem/GameProblems/Problem_a'
import Problem_b from '@/components/CommonProblem/GameProblems/Problem_b'
import Problem_c from '@/components/CommonProblem/GameProblems/Problem_c'
import Problem_d from '@/components/CommonProblem/GameProblems/Problem_d'
import Problem_e from '@/components/CommonProblem/GameProblems/Problem_e'
import Problem_f from '@/components/CommonProblem/GameProblems/Problem_f'
import Problem_g from '@/components/CommonProblem/GameProblems/Problem_g'
import Problem_h from '@/components/CommonProblem/GameProblems/Problem_h'
// yhb 常见问题 支付问题
import Pro_recharge from '@/components/CommonProblem/pay/Pro_recharge'
import haixinclone from '@/components/CommonProblem/pay/haixinclone'
// yhb 常见问题 客户端问题
import Pro_Client from '@/components/CommonProblem/khd/Pro_Client'
import Pro_SetIn from '@/components/CommonProblem/khd/Pro_SetIn'
import Pro_String from '@/components/CommonProblem/khd/Pro_String'
import Pro_Experience from '@/components/CommonProblem/khd/Pro_Experience'
import Pro_download from '@/components/CommonProblem/khd/Pro_download'

// yhb 常见问题 活动模块
import latestevents from '@/components/CommonProblem/acvit/latestevents'
import long from '@/components/CommonProblem/acvit/long'

// yhb 常见问题 账户常见问题
import free from '@/components/CommonProblem/Account/free'
import cloud from '@/components/CommonProblem/Account/cloud'
import save from '@/components/CommonProblem/Account/save'
import Configuration from '@/components/CommonProblem/Account/Configuration'
import Nogames from '@/components/CommonProblem/Account/Nogames'
import friend from '@/components/CommonProblem/Account/friend'
import Vip from '@/components/CommonProblem/Account/Vip'
import ButtonTutorial from '@/components/CommonProblem/Account/ButtonTutorial'
import What from '@/components/CommonProblem/Account/what'
import VipCashback from '@/components/CommonProblem/Account/VipCashback'

// 常见问题 安全问题
import safetysA from '@/components/CommonProblem/Safety/safetysA'
import safetysB from '@/components/CommonProblem/Safety/safetysB'

// 管理页面-文章新闻
import ManageNews from '@/components/manage/newsPage'
import addManageNews from '@/components/manage/newsPage/add'
import editManageNews from '@/components/manage/newsPage/edit'
import NoticeS from '@/components/manage/noticePage'
// eslint-disable-next-line no-undef
const router = new VueRouter({
  // mode:'history',
  routes: [{
    path: '/Center',
    name: 'Center',
    component: Center,
    redirect: '/Center/Information',
    children: [{
      path: 'card',
      name: 'card',
      component: card
    },
    {
      path: 'security',
      name: 'security',
      component: security
    },
    {
      path: 'Transfer',
      name: 'Transfer',
      component: Transfer
    },
    {
      path: 'Information',
      name: 'Information',
      component: Information
    },
    {
      path: 'Recharge',
      name: 'Recharge',
      component: Recharge
    },
    {
      path: 'Consumption',
      name: 'Consumption',
      component: Consumption
    },
    {
      path: 'Withdrawal',
      name: 'Withdrawal',
      component: Withdrawal
    },
    {
      path: 'Real_name',
      name: 'Real_name',
      component: Real_name
    },
    {
      path: 'gift_card',
      name: 'gift_card',
      component: gift_card
    },
    {
      path: 'InviteBonusList',
      name: 'InviteBonusList',
      component: InviteBonusList
    }
    ]
  },
  {
    path: '/ManageNews',
    name: 'ManageNews',
    component: ManageNews
  },
  {
    path: '/addManageNews',
    name: 'addManageNews',
    component: addManageNews
  },
  {
    path: '/editManageNews',
    name: 'editManageNews',
    component: editManageNews
  },
  {
    path: '/NoticeS',
    name: 'NoticeS',
    component: NoticeS
  },
  // yang
  {
    path: '/GameProblem',
    name: 'GameProblem',
    component: GameProblem
  },
  // yang
  {
    path: '/Account',
    name: 'Account',
    component: Account
  },
  // yang
  {
    path: '/Pay',
    name: 'Pay',
    component: Pay
  },
  // yang
  {
    path: '/Maiboxes',
    name: 'Maiboxes',
    component: Maiboxes
  },
  // yang
  {
    path: '/Setup',
    name: 'Setup',
    component: Setup
  },
  // yang
  {
    path: '/Safety',
    name: 'Safety',
    component: Safety
  },
  // yang
  {
    path: '/Community',
    name: 'Community',
    component: Community
  },
  // yang
  {
    path: '/Client',
    name: 'Client',
    component: Client
  },
  // yang
  {
    path: '/Problem_a',
    name: 'Problem_a',
    component: Problem_a
  },
  // yhb
  {
    path: '/Problem_b',
    name: 'Problem_b',
    component: Problem_b
  },
  // yhb
  {
    path: '/Pro_recharge',
    name: 'Pro_recharge',
    component: Pro_recharge
  },
  // yhb
  {
    path: '/Pro_SetIn',
    name: 'Pro_SetIn',
    component: Pro_SetIn
  },
  // yhb
  {
    path: '/Pro_String',
    name: 'Pro_String',
    component: Pro_String
  },
  // yhb
  {
    path: '/Pro_Experience',
    name: 'Pro_Experience',
    component: Pro_Experience
  },
  // yhb
  {
    path: '/activity',
    name: 'activity',
    component: activity
  },
  // yhb
  {
    path: '/latestevents',
    name: 'latestevents',
    component: latestevents
  },
  // yhb
  {
    path: '/free',
    name: 'free',
    component: free
  },
  // yhb
  {
    path: '/cloud',
    name: 'cloud',
    component: cloud
  },
  // yhb
  {
    path: '/save',
    name: 'save',
    component: save
  },
  // yhb
  {
    path: '/Configuration',
    name: 'Configuration',
    component: Configuration
  },
  // yhb
  {
    path: '/Nogames',
    name: 'Nogames',
    component: Nogames
  },
  {
    path: '/What',
    name: 'What',
    component: What
  },
  {
    path: '/VipCashback',
    name: 'VipCashback',
    component: VipCashback
  },
  // yhb
  {
    path: '/Vip',
    name: 'Vip',
    component: Vip
  },
  // yhb
  {
    path: '/friend',
    name: 'friend',
    component: friend
  },
  // yhb
  {
    path: '/ButtonTutorial',
    name: 'ButtonTutorial',
    component: ButtonTutorial
  },
  // yhb
  {
    path: '/safetysA',
    name: 'safetysA',
    component: safetysA
  },
  // yhb
  {
    path: '/long',
    name: 'long',
    component: long
  },
  // yhb
  {
    path: '/Problem_c',
    name: 'Problem_c',
    component: Problem_c
  },
  // yhb
  {
    path: '/Problem_d',
    name: 'Problem_d',
    component: Problem_d
  },
  // yhb
  {
    path: '/Problem_e',
    name: 'Problem_e',
    component: Problem_e
  },
  // yhb
  {
    path: '/safetysB',
    name: 'safetysB',
    component: safetysB
  },
  // yhb
  {
    path: '/Pro_download',
    name: 'Pro_download',
    component: Pro_download
  },
  // yhb
  {
    path: '/haixinclone',
    name: 'haixinclone',
    component: haixinclone
  },
  // Problem_f
  {
    path: '/Problem_f',
    name: 'Problem_f',
    component: Problem_f
  },
  // Problem_g
  {
    path: '/Problem_g',
    name: 'Problem_g',
    component: Problem_g
  },
  {
    path: '/Problem_h',
    name: 'Problem_h',
    component: Problem_h
  },
  {
    path: '/Pro_Client',
    name: 'Pro_Client',
    component: Pro_Client
  },
  {
    path: '/CenterNav',
    name: 'CenterNav',
    component: CenterNav
  }, {
    path: '/Forget',
    name: 'Forget',
    component: Forget
  },
  {
    path: '/SignIn',
    name: 'SignIn',
    component: SignIn
  },
  {
    path: '/Rechargeing',
    name: 'Rechargeing',
    component: Rechargeing
  },
  {
    path: '/Register',
    name: 'Register',
    component: Register
  },
  {
    path: '/BindWx',
    name: 'BindWx',
    component: BindWx
  },
  {
    path: '/UserLicense',
    name: 'UserLicense',
    component: UserLicense
  },
  {
    path: '/PrivacyPolicy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy
  },
  {
    path: '/',
    name: 'Index',
    component: Index,
    children: [{
      path: '/manual_details',
      name: 'manual_details',
      component: manual_details
    },
    {
      path: '/game_details',
      name: 'game_details',
      component: game_details
    },
    {
      path: '/Article_details',
      name: 'Article_details',
      component: Article_details
    },
    {
      path: '/Blog',
      name: 'Blog',
      component: Blog
    },
    {
      path: '/Edition_details',
      name: 'Edition_details',
      component: Edition_details
    },
    {
      path: '/problem_details',
      name: 'problem_details',
      component: problem_details
    },
    {
      path: '/aboutxy_details',
      name: 'aboutxy_details',
      component: aboutxy_details
    },
    {
      path: '/DownLoad',
      name: 'DownLoad',
      component: DownLoad
    },
    {
      path: '/Contact',
      name: 'Contact',
      component: Contact
    }, {
      path: '/faq',
      name: 'faq',
      component: faq
    },
    // {
    //   path: '/GameProblem',
    //   name: 'GameProblem',
    //   component: GameProblem
    // },
    {
      path: '/aboutus_details',
      name: 'aboutus_details',
      component: aboutus_details
    },
    {
      path: '/Home',
      name: 'Home',
      component: Home
    },
    {
      path: '*',
      redirect: '/Home'
    }
    ]
  }
  ]
})
const agent = ['Forget', 'Register', 'SignIn', 'ManageNews']
router.beforeEach(function (to, from, next) {
  if (agent.includes(to.name)) {
    const token = getCookie('user_sess')
    if (token && to.name === 'ManageNews') {
      next()
    } else {
      next('/Home')
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js